import { Service } from './service'

export class Category {
    constructor(category) {
        this.id          = category.id;
        this.name        = category.name;
        this.priority    = category.priority;
        this.description = category.description;
        this.parent_id   = category.parent_id;
        this.owner_id    = category.owner_id;
        this.created_by  = category.created_by;
        this.created_at  = category.created_at;
        this.group_id    = category.group_id;
        this.status      = category.status;
        this.services    = category.services ? this.getServiceList(category.services) : [];
        this.color_detail = category.color_detail;
        this.type         = category.type;
        // this.color_name = category.color_name;
    }

    getServiceList(services) {
        let ser_arr = [];
        for(let i = 0; i < services.length; i++) {
          ser_arr.push(new Service(services[i]));
        }
        return ser_arr;
    }
}
